import { Globe, ShieldCheck, ScrollText, Lock, FileText, Network, Activity, Shield, Layers, List, Gauge, Route, Server, Waypoints, Boxes, Bug, ShieldAlert, ShieldBan, Replace, KeyRound, Map, Radar, Rss, LayoutDashboard, type LucideIcon } from 'lucide-react';

export interface WafNavEntry {
  slug: string;
  label: string;
  icon: LucideIcon;
  disabled?: boolean;
  /** Trailing chip ("Soon") for not-yet-built entries. */
  badge?: string;
}

export interface WafNavGroup {
  heading?: string;
  entries: WafNavEntry[];
}

/**
 * Owl/Mlytics WAF console sidebar. Domains is the entry point — most other
 * features (rules, SSL, cache, firewall) are domain-anchored and land in later
 * slices, shown disabled here for roadmap context.
 */
export const WAF_NAV: WafNavGroup[] = [
  {
    entries: [
      { slug: 'overview', label: 'Overview', icon: LayoutDashboard },
      { slug: 'domains', label: 'Domains', icon: Globe },
    ],
  },
  {
    heading: 'DNS',
    entries: [
      { slug: 'dns-records', label: 'Records', icon: List },
      { slug: 'dns-requests', label: 'Requests', icon: Network },
    ],
  },
  {
    heading: 'Security',
    entries: [
      { slug: 'ssl', label: 'SSL Certificates', icon: Lock },
      { slug: 'custom-pages', label: 'Custom Pages', icon: FileText },
      { slug: 'bot-management', label: 'Bot Management', icon: Bug },
      { slug: 'account-takeover', label: 'Account Takeover', icon: ShieldAlert },
      { slug: 'rules', label: 'CRS Rules', icon: ShieldCheck },
      { slug: 'access-control', label: 'Access Control', icon: ShieldBan },
      { slug: 'firewall', label: 'Firewall Rules', icon: ScrollText },
      { slug: 'api-protection', label: 'API Protection', icon: KeyRound },
    ],
  },
  {
    heading: 'Multi-CDN',
    entries: [
      { slug: 'cdn', label: 'CDN Management', icon: Boxes },
      { slug: 'cache', label: 'Cache Control', icon: Gauge },
      { slug: 'routing', label: 'Routing Strategies', icon: Route },
      { slug: 'route-map', label: 'Route Map', icon: Map },
      { slug: 'data-feeds', label: 'Data Feeds', icon: Rss },
      { slug: 'monitors', label: 'Monitoring CDN', icon: Activity },
      { slug: 'origin-protocol', label: 'Origin Protocol', icon: Server },
      { slug: 'origin', label: 'Origin Rules', icon: Waypoints },
      { slug: 'edge-rules', label: 'Header Rewrite', icon: Replace },
    ],
  },
  {
    heading: 'Analytics',
    entries: [
      { slug: 'experience', label: 'Digital Experience', icon: Activity },
      { slug: 'pulse', label: 'Pulse', icon: Radar },
      { slug: 'origin-shield', label: 'Origin Shield', icon: Shield },
      { slug: 'multi-cdn', label: 'Multi-CDN', icon: Layers },
    ],
  },
];
